module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('v-uploader', {
    attrs: {
      "postURL": _vm.getUploadURL(),
      "isStartUpload": _vm.$store.state.startUpload
    },
    on: {
      "uploadComplete": _vm.uploadComplete,
      "uploadFail": _vm.uploadFail
    }
  }), _vm._v(" "), _c('v-preview', {
    attrs: {
      "isStartPreview": _vm.$store.state.startPreview,
      "datas": _vm.$store.state.fileInfo.currentFile
    },
    on: {
      "close": function($event) {
        _vm.close()
      }
    }
  }), _vm._v(" "), _c('v-menu-list'), _vm._v(" "), _c('v-action-list'), _vm._v(" "), _c('v-sort-list'), _vm._v(" "), _c('v-dialog'), _vm._v(" "), _c('router-view'), _vm._v(" "), _c('v-add-folder'), _vm._v(" "), _c('v-toast')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-75e17242","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 225
// module chunks = 3